import { render } from "./AppCardRouterButton.vue?vue&type=template&id=090a3f08&scoped=true&ts=true"
import script from "./AppCardRouterButton.vue?vue&type=script&lang=ts"
export * from "./AppCardRouterButton.vue?vue&type=script&lang=ts"

import "./AppCardRouterButton.vue?vue&type=style&index=0&id=090a3f08&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090a3f08"]])

export default __exports__